import { IMobileAppBanner, MobileAppBannerProps } from './types';

export const mapMobileAppBanner = ({
  prismicContent: { primary },
}: {
  prismicContent: MobileAppBannerProps['slice'];
}): IMobileAppBanner => {
  const { desktop_text: desktopText, image_2: image2 } = primary;

  return {
    ...primary,
    desktopText,
    image2,
  };
};
